var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultHomepageLogo = function SvgDefaultHomepageLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1626,
    height: 1428,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#default-homepage-logo_svg__a)",
    d: "m0 1040.84 813-469.383 813 469.383v386.7h-156.31v-296.45L813 751.945 156.308 1131.09v296.45H0zm328.532 178.64 503.592-290.749 503.586 290.749v208.06h-156.3v-117.82l-347.286-200.5-347.284 200.5v117.82H328.532zm306.203 178.64 194.183-112.11 194.182 112.11v29.42H634.735z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-homepage-logo_svg__a",
    x1: 813,
    x2: 813,
    y1: 571.457,
    y2: 1427.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AACC8",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AACC8",
    stopOpacity: 0
  })))));
};
export { SvgDefaultHomepageLogo as ReactComponent };
export default __webpack_public_path__ + "453b33742b41b8729afa88d5d4a41a88.svg";